// Login form (email + password). Reuses the app's global .text-input/.btn styles.
import { useState } from 'react';
import { useAuth } from './AuthContext';

export default function Login({ onSuccess }) {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e?.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    const { error: err } = await signIn(email, password);
    setBusy(false);
    if (err) {
      setError(err);
    } else {
      onSuccess?.();
    }
  }

  return (
    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <input
        type="email"
        className="text-input"
        placeholder="Email"
        autoComplete="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={{ width: '100%' }}
      />
      <input
        type="password"
        className="text-input"
        placeholder="Password"
        autoComplete="current-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        style={{ width: '100%' }}
      />
      {error && <div style={{ color: 'var(--red)', fontSize: 12 }}>{error}</div>}
      <button
        type="submit"
        className="btn"
        disabled={busy}
        style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#0b1220' }}
      >
        {busy ? 'Logging in…' : 'Log in'}
      </button>
    </form>
  );
}
